module.exports = __webpack_public_path__ + "img/xuanxiu.58caa4fe.png";